<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>
#app {
 font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
*{padding:0; margin:0; list-style:none;box-sizing: border-box;}
body{font-size: 16px; color: #222; font-family: "黑体";}
#app,body,html{height: 100%;}
img{max-width: 100%; vertical-align: middle; border: 0;}
.container{width: 1200px; margin: 0 auto;}
a{text-decoration: none;}
.flex{display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */  
display: -moz-box; /* Firefox 17- */  
display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */  
display: -moz-flex; /* Firefox 18+ */  
display: -ms-flexbox; /* IE 10 */  
display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */  }
.flex_sb_ac{display: flex;justify-content: space-between; align-items: center;}
.flex_sb{display: flex;justify-content: space-between;}
</style>

